import React from 'react';
import PropTypes from 'prop-types';
import AiAssistantChat from '../AiAssistantChat/aiAssistantChat';
import { api as aiAssistantApi } from '../../../actions/AiAssistant/aiAssistantActions';
import './aiAssistantSidePanel.scss';

export default function AiAssistantSidePanel({ sData, showSidePanel = false }) {
  return (
    <div className={`ais-assistant-side-panel${showSidePanel ? ' open' : ''}`}>
      <div className="ais-sp-inner">
        <AiAssistantChat sData={sData} isVisible={showSidePanel} onClose={aiAssistantApi.hideSidePanel} />
      </div>
    </div>
  );
}

AiAssistantSidePanel.propTypes = {
  sData: PropTypes.object.isRequired,
  showSidePanel: PropTypes.bool,
};
